/**
 * @generated SignedSource<<b59e064f1871e78e0bc744afc58a156f>>
 * @relayHash 3825ba996936fa9c23361c1c82392471
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f793d40604e7707d238c22072458bd4c7fbc6cb312122202bf6f362d128eb623

import type { ConcreteRequest, Query } from 'relay-runtime';
export type content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery$variables = {
  id: string;
};
export type content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery$data = {
  readonly node: {
    readonly __typename: "VirtualAgentIntentTemplate";
    readonly questions: ReadonlyArray<string>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery = {
  response: content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery$data;
  variables: content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "questions"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v3/*: any*/),
                  "action": "THROW",
                  "path": "node.questions"
                }
              ],
              "type": "VirtualAgentIntentTemplate"
            }
          ]
        },
        "action": "THROW",
        "path": "node"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "VirtualAgentIntentTemplate"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f793d40604e7707d238c22072458bd4c7fbc6cb312122202bf6f362d128eb623",
    "metadata": {},
    "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1d2f7549a67fbbe26722b4edc31dd65f";

export default node;
